import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyeOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEyeOpen"><Path fillRule="evenodd" clipRule="evenodd" d="M11.9999 4C16.239 3.99997 20.3385 6.61119 22.8881 11.5405L23.1257 11.9999L22.8881 12.4594C20.3385 17.3887 16.239 20 11.9999 20C7.76072 20 3.66123 17.3888 1.11164 12.4595L0.874023 12.0001L1.11164 11.5406C3.66123 6.6113 7.76071 4.00003 11.9999 4ZM8.49988 12C8.49988 10.067 10.0669 8.5 11.9999 8.5C13.9329 8.5 15.4999 10.067 15.4999 12C15.4999 13.933 13.9329 15.5 11.9999 15.5C10.0669 15.5 8.49988 13.933 8.49988 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEyeOpen;
